var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.714 12.714h7.573a.713.713 0 000-1.428h-7.573V3.713a.713.713 0 00-1.428 0v7.573H3.714a.714.714 0 100 1.428h7.572v7.573A.71.71 0 0012 21c.394 0 .714-.32.714-.713v-7.573"
  })));
};
export default SvgAdd;